(ns io.daskul.tutorial.webapp.app.db)

(def default-db
  {:name "Tutorial Centers"
   ;; Boot/readiness gate (SMS-70). :started? flips true when ::bootstrap fires;
   ;; the readiness phase is derived from this + [:config] + [:feature-flags].
   :bootstrap {:started? false}})
